import { Store } from 'pullstate';

// Что открыто в правой панели. mode: null | 'zone' | 'screen' | 'button'
const defaultState = { mode: null, screenId: null, buttonId: null };

const selectionStore = new Store(defaultState);

export default selectionStore;

export const selectZone = () => selectionStore.update((s) => {
  s.mode = 'zone';
  s.screenId = null;
  s.buttonId = null;
});

export const selectScreen = (screenId) => selectionStore.update((s) => {
  s.mode = 'screen';
  s.screenId = screenId;
  s.buttonId = null;
});

export const selectButton = (screenId, buttonId) => selectionStore.update((s) => {
  s.mode = 'button';
  s.screenId = screenId;
  s.buttonId = buttonId;
});

export const clearSelection = () => selectionStore.update((s) => {
  s.mode = null;
  s.screenId = null;
  s.buttonId = null;
});
